import * as React from 'react';
import { useMount } from '../core/hooks/useMount';


type Props = {
  toggleFn: () => void;
}


/**
 * ToggleSwitch: a non-rendering component that invokes the enclosed toggle function on mount
 */
const ToggleSwitch: React.FC<Props> = props => {
  useMount(() => props.toggleFn());
  return null;
};

export default ToggleSwitch;
